"use strict";

/**
* Тип прав на объекты системы.
* @since 5.0.0.4204
* @readonly
* @enum {string} ACCESS_RIGHTS
* @example 
* WebAccess.task.setAttachmentsRights(ИДзадачи, ACCESS_RIGHTS.VIEW);
*/
var ACCESS_RIGHTS = {
  /** Пусто. */
  EMPTY: 0,
  /** Нет доступа. */
  NO_ACCESS: 2,
  /** Просмотр. */
  VIEW: 4,
  /** Изменение. */
  CHANGE: 8,
  /** Полные права. */
  FULL: 16
};


/**
* Типы поддерживаемых команд.
* @since 5.0.0.1600
* @enum {string} COMMAND_TYPE
* @readonly
*/
var COMMAND_TYPE = {
  SHOW_DIALOG: 1,
  END: 2,
  EXECUTE_SEARCH: 3
};

/** 
* Базовый объект клиентской модели 
* @class BaseObjectModel
* @extends BaseObject
* @param {object} data Данные модели.
* @property {string} className имя класса
* @property {object} rawData загруженный json
*/
var BaseObjectModel = BaseObject.extend({

  /**
  * Конструктор
  * @private
  */
  init: function (data) {
    this._super(data);
    //Если данные были переданы в коструктор, то загрузим их  
    if (arguments.length > 0) this.load(data);
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  className: "BaseObjectModel",
  rawData: {},
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /* 
  * Загрузка данных текущего объекта
  * @method 
  * @param {object} JSONData
  */
  load: function (JSONData) {
    // Создаем событие "ДоЗагрузкиДанных" - 
    // может пригодиться если нам, вдруг, понадобиться подменить данные еще до включения в объект
    this.rawData = JSONData;
    this.fire("BeforeDataLoad", this.rawData);
    // Загружаем данные    
    $.extend(this, this.rawData);
    // Создаем событие "ПослеЗагрузкиДанных"
    this.fire("AfterDataLoad", this.rawData);
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Преобразовать ссылку на объект в объект типа WA.URL.
  *
  * @method WebAccess.mixins.linkMixin#toURL
  * @return {WebAccess.URL} Объект типа URL.
  */
  toURL: function () {
    var link = new WA.Link(this.ID, this.Type, this.ReferenceCode);
    var url = new WA.URL(link);
    if (this.IsNew) {
      url.setParam('mode', 'edit');
    };
    return url;
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Запуск действия.
  * @since 5.0.0.1600
  * @function BaseObjectModel.executeAction
  * @param {String} actionName Имя действия.
  * @param {Object|WebAccess.components.dialogs.FormDialog} opt_params Параметры действия или диалог, тогда значения реквизитов диалога скопируются в параметры объекта для работы действия.
  * @example 
  * WebAccess.current.executeAction('ActionName').done(function() { console.log('Действие завершилось!'); });
  */
  executeAction: function (actionName, opt_params) {
    var serializedForm;
    if (opt_params && opt_params.className === 'FormDialog') {
      // Копируем реквизиты диалога в параметры действия.
      var dialog = opt_params;
      serializedForm = dialog.form.serialize({
        onlyValue: true,
        returnRowNumber: true,
        withoutTables: true,
        transformMultiReqsToDetailRows: true
      });
    } else {
      serializedForm = {
        requisites: opt_params
      };
    }
    return this._setActionResultAndExecuteAgain(actionName, serializedForm);
  },

  /**
  * Выполнение прикладного метода.
  * @since 5.5.0.1000
  * @function BaseObjectModel.executeEntityMethod
  * @param {String} methodName Имя метода.
  * @param {Object[]} opt_parameters Параметры? с которыми должен вызваться метод.
  * @example 
  * WebAccess.current.executeEntityMethod('MethodName').done(function(result) { console.log(result); });
  */
  executeEntityMethod: function (methodName, opt_parameters) {
    throw new Error("Abstract method!");
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Запуск действия с предварительный показов диалога.
  * @since 5.0.0.1901
  * @function BaseObjectModel.showDialogAndExecuteAction
  * @param {String} actionName Имя действия.
  * @param {String} dialogName Имя диалога.
  * @example 
  * WebAccess.current.showDialogAndExecuteAction('ActionName','DialogName').done(function() { console.log('Действие завершилось!'); });
  */
  showDialogAndExecuteAction: function (actionName, dialogName) {
    var me = this;
    if (dialogName) {
      // Отображение диалога.
      WA.FC.dialogs.getObjectByName(dialogName, MODEL.FULL).done(function (dialog) {
        dialog.show();
        dialog.bind(WA.CMP.dialogs.FormDialog.EVENT.AFTER_ACTION, function (dialogActionName, result) {
          if (dialogActionName === DIALOG_ACTION.OK) {
            return me.executeAction(actionName, dialog);
          }
        });
      });
    } else {
      return this._setActionResultAndExecuteAgain(actionName);
    }
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Уставливает результат действия и запускает его повторно.
  * @since 5.0.0.1600
  * @function BaseObjectModel._setActionResultAndExecuteAgain
  * @private
  */
  _setActionResultAndExecuteAgain: function (actionName, serializedForm, commandNumber, commandType, commandResult) {
    var me = this;
    var result = $.Deferred();

    WA.SRV.call('/Action.asmx/Execute', {
      Link: (new WA.Link(me.ID, me.Type, me.ReferenceName)).toLinkModel(),
      ViewName: typeof me.ReferenceView === 'undefined' ? "" : me.ReferenceView,
      ActionName: actionName,
      SerializedForm: serializedForm || {},
      CommandNumber: commandNumber || 0,
      CommandType: commandType || 0,
      CommandResult: commandResult || {}
    }).done(function (response) {
      var responseAsObject = $.parseJSON(response);

      //скрываем сообщения о предыдущих ошибках, если были
      ErrorHide();

      // Применяем изменения к форме.
      var changes = responseAsObject.Changes;
      var changedMultiSelects = responseAsObject.ChangedMultiSelectRequisitesValues;
      if (me.form && me.form.isExist()) me.form.applyServerSideChanges(changes, changedMultiSelects);

      // Выполнение комманд.
      var cmds = responseAsObject.Commands;
      me._performCommands(cmds);

      result.resolve();

    }).fail(function (errorMessage, response) {
      // В ответе с ошибкой могут прийти изменения других реквизитов и их надо будет обработать.
      if (response) {
        if (response.Result) {
          var data = $.parseJSON(response.Result);
          // Применяем изменения к форме.
          var changes = data.Changes;
          var changedMultiSelects = data.ChangedMultiSelectRequisitesValues;
          if (me.form && me.form.isExist()) me.form.applyServerSideChanges(changes, changedMultiSelects);
        }

        result.reject(response.Error);
      } else {
        result.reject();
      }
    });

    return result.promise();
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет команду "Показать диалог".
  * @since 5.0.0.1600
  * @function BaseObjectModel._performShowDialogCommand
  * @private
  */
  _performCommands: function (cmds) {
    var result = $.Deferred();
    if (cmds.length > 0) {
      // Результаты команд.
      var commandsResult = [];

      // Запускает последовательность команд.
      var allCommandsRunner = $.Deferred();

      // Последовательность всех команд.
      var allCommandsQueue = allCommandsRunner;

      _.each(cmds, function (cmd) {
        var cmdNumber = cmd.number;
        var cmdType = cmd.type;

        allCommandsQueue = allCommandsQueue.then(function () {
          // Отложенный запуск команды.
          switch (+cmdType) {
            case COMMAND_TYPE.SHOW_DIALOG:
              // Показать диалог.
              return me._performShowDialogCommand(cmd);
            case COMMAND_TYPE.END:
              // Завершающая команда.
              return me._performEndCommand(cmd);
            case COMMAND_TYPE.EXECUTE_SEARCH:
              // Выполнить поиск.
              return me._performExecuteSeachCommand(cmd);
          }

        }).then(function (cmdResult) {
          // Сохранить результат команды.
          commandsResult.push({
            'number': cmdNumber,
            'type': cmdType,
            'result': cmdResult
          });
        });
      });

      // Ожидание выполнения команд и отправка результата снова в действие.
      allCommandsQueue.done(function allCommandsCallbackDone() {
        //TODO Шамов А.: Отправлять все результаты.
        me._setActionResultAndExecuteAgain(actionName, commandsResult[0].number, commandsResult[0].type, commandsResult[0].result).done(function () {
          result.resolve();
        });
      }).fail(function () {
        // Одна из команд прервала цепочку, остальные не выполняются и всё действие считаем незавершенным.
        result.reject();
      });

      // Запустить команды последовательно.
      allCommandsRunner.resolve();
    } else {
      result.resolve();
    }
    return result.promise();
  },

  /**
  * Выполняет команду "Показать диалог".
  * @since 5.0.0.1600
  * @function BaseObjectModel._performShowDialogCommand
  * @private
  */
  _performShowDialogCommand: function (params) {
    var def = $.Deferred();

    window.WA.factories.dialogs.getObjectByInstanceID(params.InstanceID, MODEL.FULL).done(function (d) {
      d.show();
      d.bind(WA.CMP.dialogs.FormDialog.EVENT.AFTER_ACTION, function (actionName, result) {

        var actionResult = {
          '__RESULT': result
        };

        _(d.form.serialize().requisites).each(function (v, k) {
          actionResult[k] = v[0];
        });

        def.resolve(actionResult);
      });
    }).fail(function () {
      def.reject();
    });

    return def.promise();
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет завершающую команду.
  * @since 5.0.0.1601
  * @function BaseObjectModel._performEndCommand
  * @private
  */
  _performEndCommand: function (params) {
    var def = $.Deferred();
    def.reject();
    return def.promise();
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Выполняет команду для показа результатов поиска.
  * @since 5.0.0.1601
  * @function BaseObjectModel._performExecuteSeachCommand
  * @private
  */
  _performExecuteSeachCommand: function (params) {
    var def = $.Deferred();

    var form = new WA.CMP.forms.FormBuilder("SearchResultForm");
    // TODO Будет по ИД получать каждый из объектов. Надо оптимизировать!!!
    form.addObjectList("OBJECTS", params.SearchContentKind, params.SearchResult, true);

    var dialog = new WA.CMP.dialogs.BaseDialog("SearchResultDialog");
    dialog.title = L('SEARCH_RESULT_TITLE');
    dialog.setHtml(form.render());
    dialog.width = 600;
    dialog.show();

    //TODO Когда надо будет получения выбранных элементов, то resolve нужно вызывать после выбора.
    def.resolve();
    return def.promise();
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

});







